import { Flex, DataList, DataItem } from '@cad-arc';
import { ManageUnitsEventView } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { globalAttributes } from '../../common/global-attributes';

export const EventSummary = observer(function EventSummary({
    event,
    eventStaffCount,
    resourcePatternString,
}: {
    event: ManageUnitsEventView;
    resourcePatternString?: string;
    eventStaffCount?: number;
}): React.ReactElement {
    return (
        <DataList>
            <DataItem dataKey="Location">{event.eventLocation}</DataItem>
            <DataItem dataKey="Event">{event.eventNumber}</DataItem>
            <DataItem dataKey="CFS">{event.cfsNumberAndText}</DataItem>
            <Flex alignItems="center" gap="10px">
                {eventStaffCount !== undefined && (
                    <DataItem dataKey="Event Staff Count">{eventStaffCount.toString()}</DataItem>
                )}
                {event.alarmLevel &&
                    event.agencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.FIRE && (
                        <DataItem dataKey="Alarm Level">{event.alarmLevel.label}</DataItem>
                    )}
            </Flex>
            {resourcePatternString && (
                <DataItem dataKey="Resource Pattern">{resourcePatternString}</DataItem>
            )}
        </DataList>
    );
});
